import React from 'react';
import styled from 'styled-components';

interface PluginBrowseBetterProps {
    width?: number;
    height?: number;
}

const StyledSVG = styled.svg`
    display: block;
`;

export const PluginDragDrop: React.FC<PluginBrowseBetterProps> = ({
    width = 56,
}) => (
    <StyledSVG
        viewBox="0 0 100 100"
        width={width}
        height={width * 1}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="MVP---Plug-&amp;-Play-"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Plugin---Assets"
                transform="translate(-524.000000, -2293.000000)"
            >
                <rect
                    fill="#0C1B2B"
                    x="0"
                    y="0"
                    width="1440"
                    height="3108"
                ></rect>
                <g
                    id="icn/USP/DragDrop"
                    transform="translate(524.000000, 2293.000000)"
                >
                    <rect
                        id="Combined-Shape"
                        stroke="#3F5365"
                        x="17.5"
                        y="67.5"
                        width="65"
                        height="22"
                        rx="1"
                    ></rect>
                    <line
                        x1="33.5"
                        y1="75.8"
                        x2="33.5"
                        y2="82.2"
                        id="Line-4"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="39.5"
                        y1="77"
                        x2="39.5"
                        y2="81"
                        id="Line-4-Copy"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="45.5"
                        y1="75.8"
                        x2="45.5"
                        y2="82.2"
                        id="Line-4-Copy-2"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="51.5"
                        y1="75.8"
                        x2="51.5"
                        y2="82.2"
                        id="Line-4-Copy-14"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="63.5"
                        y1="73.7857143"
                        x2="63.5"
                        y2="83.2142857"
                        id="Line-4-Copy-3"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="57.5"
                        y1="73.7857143"
                        x2="57.5"
                        y2="83.2142857"
                        id="Line-4-Copy-9"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="69.5"
                        y1="71.3947368"
                        x2="69.5"
                        y2="85.9282297"
                        id="Line-4-Copy-4"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="75.5"
                        y1="75.8"
                        x2="75.5"
                        y2="82.2"
                        id="Line-4-Copy-5"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="21.5"
                        y1="77.6666667"
                        x2="21.5"
                        y2="80.3333333"
                        id="Line-4-Copy-12"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="27.5"
                        y1="72.3823529"
                        x2="27.5"
                        y2="84.8556507"
                        id="Line-4-Copy-13"
                        stroke="#3F5365"
                        strokeLinecap="round"
                    ></line>
                    <g
                        id="Group"
                        transform="translate(1.000000, 0.000000)"
                        stroke="#3F5365"
                    >
                        <rect
                            id="Combined-Shape-Copy"
                            transform="translate(33.000000, 11.500000) rotate(-180.000000) translate(-33.000000, -11.500000) "
                            x="0.5"
                            y="0.5"
                            width="65"
                            height="22"
                            rx="1"
                        ></rect>
                        <line
                            x1="49.5"
                            y1="7.8"
                            x2="49.5"
                            y2="14.2"
                            id="Line-4"
                            strokeLinecap="round"
                            transform="translate(49.500000, 11.000000) rotate(-180.000000) translate(-49.500000, -11.000000) "
                        ></line>
                        <line
                            x1="43.5"
                            y1="9"
                            x2="43.5"
                            y2="13"
                            id="Line-4-Copy"
                            strokeLinecap="round"
                            transform="translate(43.500000, 11.000000) rotate(-180.000000) translate(-43.500000, -11.000000) "
                        ></line>
                        <line
                            x1="37.5"
                            y1="7.8"
                            x2="37.5"
                            y2="14.2"
                            id="Line-4-Copy-2"
                            strokeLinecap="round"
                            transform="translate(37.500000, 11.000000) rotate(-180.000000) translate(-37.500000, -11.000000) "
                        ></line>
                        <line
                            x1="31.5"
                            y1="7.8"
                            x2="31.5"
                            y2="14.2"
                            id="Line-4-Copy-14"
                            strokeLinecap="round"
                            transform="translate(31.500000, 11.000000) rotate(-180.000000) translate(-31.500000, -11.000000) "
                        ></line>
                        <line
                            x1="19.5"
                            y1="6.78571429"
                            x2="19.5"
                            y2="16.2142857"
                            id="Line-4-Copy-3"
                            strokeLinecap="round"
                            transform="translate(19.500000, 11.500000) rotate(-180.000000) translate(-19.500000, -11.500000) "
                        ></line>
                        <line
                            x1="25.5"
                            y1="6.78571429"
                            x2="25.5"
                            y2="16.2142857"
                            id="Line-4-Copy-9"
                            strokeLinecap="round"
                            transform="translate(25.500000, 11.500000) rotate(-180.000000) translate(-25.500000, -11.500000) "
                        ></line>
                        <line
                            x1="13.5"
                            y1="4.39473684"
                            x2="13.5"
                            y2="18.9282297"
                            id="Line-4-Copy-4"
                            strokeLinecap="round"
                            transform="translate(13.500000, 11.500000) rotate(-180.000000) translate(-13.500000, -11.500000) "
                        ></line>
                        <line
                            x1="7.5"
                            y1="7.8"
                            x2="7.5"
                            y2="14.2"
                            id="Line-4-Copy-5"
                            strokeLinecap="round"
                            transform="translate(7.500000, 11.000000) rotate(-180.000000) translate(-7.500000, -11.000000) "
                        ></line>
                        <line
                            x1="61.5"
                            y1="9.66666667"
                            x2="61.5"
                            y2="12.3333333"
                            id="Line-4-Copy-12"
                            strokeLinecap="round"
                            transform="translate(61.500000, 11.000000) rotate(-180.000000) translate(-61.500000, -11.000000) "
                        ></line>
                        <line
                            x1="55.5"
                            y1="5.38235294"
                            x2="55.5"
                            y2="17.8556507"
                            id="Line-4-Copy-13"
                            strokeLinecap="round"
                            transform="translate(55.500000, 11.500000) rotate(-180.000000) translate(-55.500000, -11.500000) "
                        ></line>
                    </g>
                    <g
                        id="Group-Copy-2"
                        transform="translate(78.000000, 0.000000)"
                        stroke="#3F5365"
                    >
                        <rect
                            id="Combined-Shape-Copy"
                            transform="translate(10.500000, 11.500000) rotate(-180.000000) translate(-10.500000, -11.500000) "
                            x="0.5"
                            y="0.5"
                            width="20"
                            height="22"
                            rx="1"
                        ></rect>
                        <line
                            x1="5.5"
                            y1="7.8"
                            x2="5.5"
                            y2="14.2"
                            id="Line-4"
                            strokeLinecap="round"
                            transform="translate(5.500000, 11.000000) rotate(-180.000000) translate(-5.500000, -11.000000) "
                        ></line>
                        <line
                            x1="17.5"
                            y1="9.66666667"
                            x2="17.5"
                            y2="12.3333333"
                            id="Line-4-Copy-12"
                            strokeLinecap="round"
                            transform="translate(17.500000, 11.000000) rotate(-180.000000) translate(-17.500000, -11.000000) "
                        ></line>
                        <line
                            x1="11.5"
                            y1="5.38235294"
                            x2="11.5"
                            y2="17.8556507"
                            id="Line-4-Copy-13"
                            strokeLinecap="round"
                            transform="translate(11.500000, 11.500000) rotate(-180.000000) translate(-11.500000, -11.500000) "
                        ></line>
                    </g>
                    <g id="Group-2" transform="translate(1.000000, 32.000000)">
                        <g
                            id="Group-Copy"
                            transform="translate(20.000000, 6.000000)"
                            stroke="#32CBCB"
                            strokeLinecap="round"
                        >
                            <line
                                x1="0.5"
                                y1="8"
                                x2="0.5"
                                y2="16"
                                id="Line-4"
                            ></line>
                            <line
                                x1="6.5"
                                y1="9.16666667"
                                x2="6.5"
                                y2="13.8333333"
                                id="Line-4-Copy"
                            ></line>
                            <line
                                x1="12.5"
                                y1="8"
                                x2="12.5"
                                y2="16"
                                id="Line-4-Copy-2"
                            ></line>
                            <line
                                x1="18.5"
                                y1="8"
                                x2="18.5"
                                y2="16"
                                id="Line-4-Copy-14"
                            ></line>
                            <line
                                x1="30.5"
                                y1="6"
                                x2="30.5"
                                y2="18"
                                id="Line-4-Copy-3"
                            ></line>
                            <line
                                x1="24.5"
                                y1="6"
                                x2="24.5"
                                y2="18"
                                id="Line-4-Copy-9"
                            ></line>
                            <line
                                x1="36.5"
                                y1="1.09090909"
                                x2="36.5"
                                y2="22.9090909"
                                id="Line-4-Copy-4"
                            ></line>
                            <line
                                x1="42.5"
                                y1="8"
                                x2="42.5"
                                y2="16"
                                id="Line-4-Copy-5"
                            ></line>
                            <line
                                x1="48.5"
                                y1="3.05555556"
                                x2="48.5"
                                y2="19.7861111"
                                id="Line-4-Copy-6"
                            ></line>
                            <line
                                x1="54.5"
                                y1="8"
                                x2="54.5"
                                y2="16"
                                id="Line-4-Copy-7"
                            ></line>
                            <line
                                x1="60.5"
                                y1="9.16666667"
                                x2="60.5"
                                y2="13.8333333"
                                id="Line-4-Copy-8"
                            ></line>
                        </g>
                        <rect
                            id="Rectangle-Copy"
                            stroke="#ADB7BF"
                            x="0.5"
                            y="0.5"
                            width="94"
                            height="35"
                            rx="1"
                        ></rect>
                        <path
                            d="M11,12 C14.3137085,12 17,14.6862915 17,18 C17,21.3137085 14.3137085,24 11,24 C7.6862915,24 5,21.3137085 5,18 C5,14.6862915 7.6862915,12 11,12 Z M9.60930115,15.0159467 L9.60930115,21.0159467 L13.6093012,18.0159467 L9.60930115,15.0159467 Z"
                            id="Combined-Shape"
                            fill="#32CBCB"
                        ></path>
                    </g>
                    <g
                        id="Group-21"
                        transform="translate(79.779758, 51.002985)"
                        fill="#ADB7BF"
                        stroke="#ADB7BF"
                    >
                        <polygon
                            id="Path-7"
                            points="-2.93098879e-13 1.77635684e-14 -2.93098879e-13 12.8571429 3.83449049 9.21311654 9.95774648 9.21311654"
                        ></polygon>
                        <path
                            d="M8.76870909,14.3541579 C10.7909189,14.3541579 12.6215898,15.177461 13.9467716,16.5082659 C15.272718,17.8398386 16.0926528,19.6794389 16.0926528,21.7113008 C16.0926528,23.7431627 15.272718,25.5827629 13.9467716,26.9143357 C12.6215898,28.2451406 10.7909189,29.0684436 8.76870909,29.0684436 C6.74649925,29.0684436 4.91582835,28.2451406 3.5906466,26.9143357 C2.2647002,25.5827629 1.44476543,23.7431627 1.44476543,21.7113008 C1.44476543,19.6794389 2.2647002,17.8398386 3.5906466,16.5082659 C4.91582835,15.177461 6.74649925,14.3541579 8.76870909,14.3541579 Z M9.98001368,17.6398722 L7.55755982,17.6398722 L7.55688373,20.4963085 L4.71237107,20.4971657 L4.71237107,22.9256618 L7.55688373,22.9252333 L7.55755977,25.7827294 L9.98001367,25.7827294 L9.97980241,22.9252333 L12.8250471,22.9256618 L12.8250471,20.4971657 L9.97980241,20.4963085 L9.98001368,17.6398722 Z"
                            id="Combined-Shape"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </StyledSVG>
);

export default PluginDragDrop;
